// Components
import Analytics from "./components/analytics";
import HangingPunctuation from "./components/hanging-punctuation";
import ArticleContent from "./components/article-content";
import ProgramMap from "./components/program-map";
import WorldMap from "./components/world-map";
import Menu from "./components/menu";
import Carousel from "./components/carousel";
import InlineCarousel from "./components/inline-carousel";
import Tables from "./components/tables";
import FilteredSearch from "./components/filtered-search";
import ActionBox from "./components/action-box";
import DeviceTargeting from "./components/device-targeting";
import DigitalResources from "./components/digital-resources";

// Third-party
const $ = window.jQuery;
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes";
import "./vendor/jquery.inview";

// Load
$(document).ready(() => {
  new HangingPunctuation();
  new ArticleContent();
  new WorldMap();
  new Menu();
  new Analytics();
  new Carousel();
  new InlineCarousel();
  new Tables();
  new FilteredSearch();
  new ActionBox();
  new ProgramMap();
  new DeviceTargeting();
  new DigitalResources();
});
